export default abstract class AbsEditViewValueFormatter
{
  abstract format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any);

  abstract parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any, oldValue?: any);
}
